import { http } from '../../config/axios'

const findNotaFiscal = (params: any): Promise<any> => {
  const queryParams = params
    ? Object.keys(params)
          .map((k) => encodeURIComponent(params[k]))
          .join('/')
    : '';
  return http
    .get('api/nota-fiscal/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findNotaFiscal', error)
      throw Error(error.response.data)
    })
}

export default findNotaFiscal;
